// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AssetValuationV2Fragment } from './entityValuationQueries.generated';
import { gql } from '@apollo/client';
import { AssetValuationV2FragmentDoc } from './entityValuationQueries.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAssetValuationMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateAssetValuationV2Input;
}>;


export type CreateAssetValuationMutation = { __typename?: 'Mutation', createAssetValuationV2: (
    { __typename?: 'AssetValuationV2' }
    & AssetValuationV2Fragment
  ) };

export type UpdateAssetValuationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateAssetValuationV2Input;
}>;


export type UpdateAssetValuationMutation = { __typename?: 'Mutation', updateAssetValuationV2: (
    { __typename?: 'AssetValuationV2' }
    & AssetValuationV2Fragment
  ) };

export type DeleteAssetValuationMutationVariables = Types.Exact<{
  assetValuationId: Types.Scalars['ID']['input'];
}>;


export type DeleteAssetValuationMutation = { __typename?: 'Mutation', deleteAssetValuationv2: string };

export type UpsertAssetToCurrentValuationWithEntityUpdatesMutationVariables = Types.Exact<{
  entityID: Types.Scalars['ID']['input'];
  input: Array<Types.AugmentedCreateAssetV2Input> | Types.AugmentedCreateAssetV2Input;
  updateEntities: Array<Types.AugmentedUpdateEntityInput> | Types.AugmentedUpdateEntityInput;
}>;


export type UpsertAssetToCurrentValuationWithEntityUpdatesMutation = { __typename?: 'Mutation', upsertAssetToCurrentValuation: { __typename?: 'Entity', id: string }, updateEntities: Array<{ __typename?: 'Entity', id: string } | null> };

export const Operations = {
  Mutation: {
    CreateAssetValuation: 'CreateAssetValuation' as const,
    UpdateAssetValuation: 'UpdateAssetValuation' as const,
    DeleteAssetValuation: 'DeleteAssetValuation' as const,
    UpsertAssetToCurrentValuationWithEntityUpdates: 'UpsertAssetToCurrentValuationWithEntityUpdates' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateAssetValuationDocument = gql`
    mutation CreateAssetValuation($input: AugmentedCreateAssetValuationV2Input!) {
  createAssetValuationV2(input: $input) {
    ...AssetValuationV2
  }
}
    ${AssetValuationV2FragmentDoc}`;
export type CreateAssetValuationMutationFn = Apollo.MutationFunction<CreateAssetValuationMutation, CreateAssetValuationMutationVariables>;

/**
 * __useCreateAssetValuationMutation__
 *
 * To run a mutation, you first call `useCreateAssetValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetValuationMutation, { data, loading, error }] = useCreateAssetValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetValuationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetValuationMutation, CreateAssetValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetValuationMutation, CreateAssetValuationMutationVariables>(CreateAssetValuationDocument, options);
      }
export type CreateAssetValuationMutationHookResult = ReturnType<typeof useCreateAssetValuationMutation>;
export type CreateAssetValuationMutationResult = Apollo.MutationResult<CreateAssetValuationMutation>;
export type CreateAssetValuationMutationOptions = Apollo.BaseMutationOptions<CreateAssetValuationMutation, CreateAssetValuationMutationVariables>;
export const UpdateAssetValuationDocument = gql`
    mutation UpdateAssetValuation($input: AugmentedUpdateAssetValuationV2Input!) {
  updateAssetValuationV2(input: $input) {
    ...AssetValuationV2
  }
}
    ${AssetValuationV2FragmentDoc}`;
export type UpdateAssetValuationMutationFn = Apollo.MutationFunction<UpdateAssetValuationMutation, UpdateAssetValuationMutationVariables>;

/**
 * __useUpdateAssetValuationMutation__
 *
 * To run a mutation, you first call `useUpdateAssetValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetValuationMutation, { data, loading, error }] = useUpdateAssetValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetValuationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssetValuationMutation, UpdateAssetValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssetValuationMutation, UpdateAssetValuationMutationVariables>(UpdateAssetValuationDocument, options);
      }
export type UpdateAssetValuationMutationHookResult = ReturnType<typeof useUpdateAssetValuationMutation>;
export type UpdateAssetValuationMutationResult = Apollo.MutationResult<UpdateAssetValuationMutation>;
export type UpdateAssetValuationMutationOptions = Apollo.BaseMutationOptions<UpdateAssetValuationMutation, UpdateAssetValuationMutationVariables>;
export const DeleteAssetValuationDocument = gql`
    mutation DeleteAssetValuation($assetValuationId: ID!) {
  deleteAssetValuationv2(id: $assetValuationId)
}
    `;
export type DeleteAssetValuationMutationFn = Apollo.MutationFunction<DeleteAssetValuationMutation, DeleteAssetValuationMutationVariables>;

/**
 * __useDeleteAssetValuationMutation__
 *
 * To run a mutation, you first call `useDeleteAssetValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetValuationMutation, { data, loading, error }] = useDeleteAssetValuationMutation({
 *   variables: {
 *      assetValuationId: // value for 'assetValuationId'
 *   },
 * });
 */
export function useDeleteAssetValuationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetValuationMutation, DeleteAssetValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetValuationMutation, DeleteAssetValuationMutationVariables>(DeleteAssetValuationDocument, options);
      }
export type DeleteAssetValuationMutationHookResult = ReturnType<typeof useDeleteAssetValuationMutation>;
export type DeleteAssetValuationMutationResult = Apollo.MutationResult<DeleteAssetValuationMutation>;
export type DeleteAssetValuationMutationOptions = Apollo.BaseMutationOptions<DeleteAssetValuationMutation, DeleteAssetValuationMutationVariables>;
export const UpsertAssetToCurrentValuationWithEntityUpdatesDocument = gql`
    mutation UpsertAssetToCurrentValuationWithEntityUpdates($entityID: ID!, $input: [AugmentedCreateAssetV2Input!]!, $updateEntities: [AugmentedUpdateEntityInput!]!) {
  upsertAssetToCurrentValuation(entityID: $entityID, input: $input) {
    id
  }
  updateEntities(input: $updateEntities) {
    id
  }
}
    `;
export type UpsertAssetToCurrentValuationWithEntityUpdatesMutationFn = Apollo.MutationFunction<UpsertAssetToCurrentValuationWithEntityUpdatesMutation, UpsertAssetToCurrentValuationWithEntityUpdatesMutationVariables>;

/**
 * __useUpsertAssetToCurrentValuationWithEntityUpdatesMutation__
 *
 * To run a mutation, you first call `useUpsertAssetToCurrentValuationWithEntityUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssetToCurrentValuationWithEntityUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssetToCurrentValuationWithEntityUpdatesMutation, { data, loading, error }] = useUpsertAssetToCurrentValuationWithEntityUpdatesMutation({
 *   variables: {
 *      entityID: // value for 'entityID'
 *      input: // value for 'input'
 *      updateEntities: // value for 'updateEntities'
 *   },
 * });
 */
export function useUpsertAssetToCurrentValuationWithEntityUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssetToCurrentValuationWithEntityUpdatesMutation, UpsertAssetToCurrentValuationWithEntityUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssetToCurrentValuationWithEntityUpdatesMutation, UpsertAssetToCurrentValuationWithEntityUpdatesMutationVariables>(UpsertAssetToCurrentValuationWithEntityUpdatesDocument, options);
      }
export type UpsertAssetToCurrentValuationWithEntityUpdatesMutationHookResult = ReturnType<typeof useUpsertAssetToCurrentValuationWithEntityUpdatesMutation>;
export type UpsertAssetToCurrentValuationWithEntityUpdatesMutationResult = Apollo.MutationResult<UpsertAssetToCurrentValuationWithEntityUpdatesMutation>;
export type UpsertAssetToCurrentValuationWithEntityUpdatesMutationOptions = Apollo.BaseMutationOptions<UpsertAssetToCurrentValuationWithEntityUpdatesMutation, UpsertAssetToCurrentValuationWithEntityUpdatesMutationVariables>;